/**
 * Предложение: id периодов продукта, для которых поле количествно не используется
 */

export const lifespanPeriodIdsWithoutQty = [0, 1];
